export const STORE_KEY = 'sections';
